<!--<input pInputText placeholder="apartment id" [(ngModel)]="id"/>-->
<!--<input pInputText placeholder="image src" [(ngModel)]="src"/>-->
<!--<p-button (onClick)="onSubmit()">Submit</p-button>-->

@if (apartments$ | async; as apartments) {
  <p-table
    [value]="apartments" selectionMode="single" [selection]="apartments">
    <ng-template pTemplate="header">
      <tr>
        <th>Id</th>
        <th>Name</th>
        <th>Updated at</th>
        <th>End date</th>
        <th>Status</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-apartment [cTypedTableRow]="apartments">
      <tr>
        <td><a [routerLink]="['/apartments', apartment.id]" class="link" >{{ apartment.id }}</a></td>
        <td>{{ apartment.name }}</td>
        <td>{{ apartment.lastUpdated | date:'M/d/yy, h:mm a' }}</td>
        <td>{{ apartment.endDate | date:'M/d/yy, h:mm a' }}</td>
        <td>{{ apartment.status }}</td>
      </tr>
    </ng-template>
  </p-table>
}


